import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const SystemThreatsAndSecurity = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="System Threats and Security"
    videos={[
      "https://www.youtube.com/embed/YfZXGVN-zlk?si=mcP3cHPOlC70p6Ou",
      "https://www.youtube.com/embed/wVQ6EsYKaIA?si=bT3pfHWWYyHcVfgh",
      "https://www.youtube.com/embed/DKb7KhfoZmU?si=Frus6Unl_jR2xVQB",
      "https://www.youtube.com/embed/n_zafEFPA0g?si=M4NMh9-6iFDNoKMl"
    ]}
    takeaways={[]}
    questions={[
      "1) What is Access Matrix List? Discuss how Unix implements of Access Matrix for providing security in detail with appropriate case study and discussion.",
      "2) Explore the concept of capability-based systems in the context of security and resource management. Analyze how capabilities differ from traditional access control mechanisms, and evaluate their advantages and disadvantages in real-world applications. In what scenarios would implementing a capability-based approach be more beneficial than conventional methods? Provide examples to support your analysis, and discuss the potential challenges organizations might face when transitioning to capability-based systems."
    ]}
    exampleVideos={[]}
  />
);
}

export default SystemThreatsAndSecurity;
